export default "__VITE_ASSET__f8cff419__"